import {Entity} from "../../../model";
import {CellContext} from "@tanstack/react-table";

export const DateCell = <E extends Entity>(props: CellContext<E, any>) => {
    const date = new Date(`${props.getValue()}`);
    return date ? date.toLocaleDateString() : undefined
}